import { atom } from 'recoil';
import { UiConfiguration } from "../App";

export const uiConfiguration = atom<UiConfiguration | undefined>({
	key: "ui-configuration",
	default: undefined
});
